import axios from 'axios';
import QS from "qs"
let baseUrlStr = "https://api.caoshalove.top"
var instance = axios.create();
if (process.env.NODE_ENV == "development") {
	instance.defaults.baseURL = process.env.VUE_APP_SERVICE_URL
} else if (process.env.NODE_ENV == "production") {
	instance.defaults.baseURL = baseUrlStr
	// instance.url =  baseUrlStr
	// instance.url = baseUrlStr + (instance.defaults.baseURL).split(/\/api\//)[1]
}


// axios.defaults.timeout = 10000;
// axios.defaults.baseURL ='http://192.168.1.95:9540/';
// let Sign = ''
function getUid(length) {
	return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
}
//http request 拦截器
instance.interceptors.request.use(
	config => {
       console.log(config)
	      config.headers.common['type'] = window.sessionStorage.getItem('type')
		if (process.env.NODE_ENV == "production") {
			console.log(config)
				console.log( config.url)
				var testUrl =  config.url
             console.log( config.url.split(/apis\//)[1])

	    config.url = baseUrlStr + '/'+ config.url.split(/apis\//)[1]
		// 	console.log(baseUrlStr + config.url.split(/\/dev-api\//)[1])
		 }

		 console.log(testUrl)
		 console.log(window.sessionStorage.getItem('token'))
		if(testUrl == "apis/mark/number/add"  || testUrl == "apis/mark/number/delete" ||testUrl == "apis/mark/record/lottery"||testUrl == "apis/mark/record/add" || testUrl == "apis/mark/picture/add" || testUrl == "apis/mark/picture/delete"|| testUrl == "apis/mark/picture/addImg"){
            var token  = window.sessionStorage.getItem('token')
					 if (token) {
					  console.log('加了token')

					  //config.headers.common['Authorization'] ='bear' +  window.sessionStorage.getItem('token')
					  config.headers.common['token'] = window.sessionStorage.getItem('token')


					}else{
						console.log('没有token')
						}
		   }else{
			  console.log('不用加token')
		   }




		return config;
	},
	error => {
		return Promise.reject(err);
	}
);


//http response 拦截器
instance.interceptors.response.use(
	response => {
		if (response.data.errCode == 2 ) {

			router.push({
				path: "/login",
				query: {
					redirect: router.currentRoute.fullPath
				} //从哪个页面跳转
			})
		}
		return response;
	},
	error => {
		return Promise.reject(error)
	}
)


/**
 * 封装get方法
 */

export function get(url, params = {}) {
	// 赋值签名
	// Sign = JSON.stringify(params)
	return new Promise((resolve, reject) => {
		instance.get(url, {
				params: params
			})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}


/**
 * 封装post请求
 */

// export function post(url, data = {}) {
// 	// 赋值签名
// 	// Sign = JSON.stringify(data)
// 	return new Promise((resolve, reject) => {
// 		instance.post(url, data)
// 			.then(response => {
// 				resolve(response.data);
// 			}, err => {
// 				reject(err)
// 			})
// 	})
// }

export function post(url, params) {
    return new Promise((resolve, reject) => {
			// Sign = QS.stringify(params)
		console.log(QS.stringify(params))
          instance.post(url, QS.stringify(params))
        .then(res => {
            resolve(res.data);
        })
        .catch(err =>{
            reject(err.data)
        })
    });
}



// WEBPACK FOOTER //
// ./src/untils/http.js